import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';

import BlockIcon from '@material-ui/icons/Block';
import BatchContext from '@components/batch/batch-upload-edit/batch-context';
import { getBatchRow } from '@selectors/batch-edit-selector';
import './skipped-warning.scss';

const SkippedWarning = () => {
  const { fileId, rowId } = useContext(BatchContext);
  const batchRow = useSelector(state => getBatchRow(state, fileId, rowId));

  if (batchRow?.skipped === true) {
    return (
      <div styleName="skipped-warning-container">
        <div styleName="skipped-icon">
          <BlockIcon htmlColor="#ED6C02" style={{ fontSize: '1.5rem' }} />
        </div>
        <div styleName="skipped-message">
          This entity will not be uploaded.
        </div>
      </div>
    );
  }

  return null;
};

export default memo(SkippedWarning);
